module.exports = __webpack_public_path__ + "static/media/Nguyen_Xuan_Anh.23a7dbd9.jpg";